<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">618活动效果回顾</div>
    <div>今年618，店铺发出<span class="font_color">&nbsp;{{ data.marketingSmsNum618 }}&nbsp;</span>条短信</div>
    <div>今年618，营销带来<span class="font_color">&nbsp;{{ data.marketingRetrieveMoney618 }}&nbsp;</span>元营收</div>
    <div style="margin-top: 30px;">心中有数，脚下有路。</div>
    <div>店铺大促营收增量潜力可观！</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;

  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P5.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;


  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .font_color {
    color: #0b79ff;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
